import React from "react";
import AppBody from "../components/AppBody";

const TrainerHomeDashboard = () => {
  return (
    <AppBody
      content={
        <div>
          <h1>Trainer  Dashboard</h1>
        </div>
      }
    />
  );
};

export default TrainerHomeDashboard;
